module.exports = __webpack_public_path__ + "img/纠错.faf6ae3f.png";